import { useCopyToClipboard } from '@/hooks/clipboard';
import {
  downloadTextFile,
  RECOVERY_CODES_FILENAME,
  recoveryCodesText,
} from '@/utils/mfa';
import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import GetAppIcon from '@material-ui/icons/GetApp';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  codes: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(1, 4),
    margin: 0,
    padding: theme.spacing(2, 3),
    listStyle: 'none',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.action.hover,
    ...theme.typography.body1,
    fontFamily: 'monospace',
    fontSize: '1.0625rem',
    letterSpacing: '0.05em',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(1, 2),
      padding: theme.spacing(2),
    },
  },
}));

interface RecoveryCodesListProps {
  codes: string[];
  email?: string | null;
}

/** Recovery codes in a grid, with Copy and Download. */
export default function RecoveryCodesList({
  codes,
  email,
}: RecoveryCodesListProps): JSX.Element {
  const classes = useStyles();
  const copy = useCopyToClipboard(
    'Recovery codes copied',
    'Could not copy. Download the codes instead.',
  );

  return (
    <>
      <ul className={classes.codes} aria-label="Recovery codes">
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ul>
      <Box display="flex" mt={2} gridGap={8}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<FileCopyOutlinedIcon />}
          onClick={() => copy(recoveryCodesText(codes, email))}
        >
          Copy
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<GetAppIcon />}
          onClick={() =>
            downloadTextFile(
              RECOVERY_CODES_FILENAME,
              recoveryCodesText(codes, email),
            )
          }
        >
          Download
        </Button>
      </Box>
    </>
  );
}
